import { mq } from "@certn/cascadia-react";
import { css } from "@emotion/css";

interface Props {
  children: React.ReactNode;
}

export function AuthLayout(props: Props) {
  const { children } = props;

  return (
    <div
      className={css(
        styles.container,
        mq({
          backgroundColor: ["var(--surface-overlay)", "var(--surface-sunken)"],
        })
      )}
    >
      <div
        className={css(
          styles.card,
          {
            background: "var(--surface-overlay)",
          },
          mq({
            boxShadow: [undefined, "var(--shadow-deep)"],
          })
        )}
      >
        {children}
      </div>
    </div>
  );
}

const styles = {
  container: css(
    {
      minHeight: "100vh",
    },
    mq({ display: ["block", "flex"] })
  ),
  card: css(
    {
      gap: "var(--space-6)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "auto",
      boxSizing: "border-box",
      padding: "var(--space-10)",
      borderRadius: "var(--border-radius-3)",
    },
    mq({
      width: [undefined, 400],
    })
  ),
};
